import { MONTHS } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useGetIncomeChartData } from "@/services";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useBudgetIncomeChart = () => {
  const [chartData, setChartData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Budget Income",
        data: [],
        borderColor: "#B0C01A",
        backgroundColor: "#B0C01A",
        tension: 0.4,
        pointStyle: "circle",
        pointRadius: 6,
      },
      {
        label: "Actual Income",
        data: [],
        borderColor: "#245DB1",
        backgroundColor: "#245DB1",
        tension: 0.4,
        pointStyle: "circle",
        pointRadius: 6,
      },
    ],
  });

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );

  const { data: chartAPIData, isLoading: isChartDataLoading } =
    useGetIncomeChartData({
      communityId: communityDetail?.communityId,
      year: currentFinanceYear,
      queryParams: {
        enabled: !!(communityDetail?.communityId && currentFinanceYear),
      },
    });

  useEffect(() => {
    if (chartAPIData) {
      const budgetIncome = MONTHS?.map((mon: string) => {
        return chartAPIData?.data?.find(
          (val: any) => val?.monthName?.toLowerCase() == mon?.toLowerCase()
        )?.budgetAmount;
      });
      const actualIncome = MONTHS?.map((mon: string) => {
        return chartAPIData?.data?.find(
          (val: any) => val?.monthName?.toLowerCase() == mon?.toLowerCase()
        )?.actualAmount;
      });

      let _chartData = { ...chartData };
      _chartData = {
        labels: MONTHS as any,
        datasets: [
          {
            ..._chartData["datasets"][0],
            data: budgetIncome,
          },
          {
            ..._chartData["datasets"][1],
            data: actualIncome,
          },
        ],
      };
      setChartData({ ..._chartData });
    }
  }, [chartAPIData]);

  return {
    chartData,
    isChartDataLoading,
    currentFinanceYear,
  };
};

export default useBudgetIncomeChart;
